import {Inject, Injectable} from '@angular/core';
import {AccountControllerService} from '../../modules/apiModule1/api/account-controller.service';
import {StorageService} from './storage.service';
import {USERKEY} from '../../app.config';
import {BehaviorSubject, lastValueFrom} from 'rxjs';
import {UserPermissionsService} from './user-permissions.service';


@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private readonly emptyUser = {} as User;

  get isEmpty(): boolean{
    const {email, firstName, lastName, middleName, userName, rights} = this.user$.value;
    return !email && !firstName && !lastName && !middleName && !userName && !rights;
  }

  // private userData: User = this.emptyUser;

  user$ = new BehaviorSubject<User>(this.emptyUser);

  user = this.user$.asObservable();

  get value(): User {
    return this.user$.value;
  }


  constructor(
    private accountController: AccountControllerService,
    private storage: StorageService,
    @Inject(USERKEY) private userkey: string,
    private permissionsService: UserPermissionsService
  ) {
  }


  clearUser(): void {
    this.user$.next(this.emptyUser);
  }

  fetchUser(): void {
    const key = this.storage.getItem(this.userkey);
    if (!key) return;
    this.accountController.apiAccountCurrentGet('body').subscribe({
      next: (data) => {
        this.permissionsService.setPermissions(data.rights);
        this.user$.next(data);
        console.info('user', data);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  async awaitingFetchUser(): Promise<any> {
    return lastValueFrom(this.accountController.apiAccountCurrentGet())
  }

}


